import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Rating from 'components/Rating'
import Tooltip from 'components/Tooltip'
import { useEventContext } from 'context/EventContext'

import classes from './RatingComparison.module.scss'

const RATING_NAMES = {
  rating_ease: 'Ease of Use',
  rating_features: 'Features',
  rating_value: 'Value for Money',
  rating_support: 'Customer Support',
}

const RatingComparison = ({ listing, ratingWinners }) => {
  const { sendEvent } = useEventContext()
  return (
    <div className={classes.root}>
      {Object.keys(RATING_NAMES).map(key => {
        const isWinner = ratingWinners[key].slug === listing.slug
        return (
          <div key={key} className={clsx(classes.row, { [classes.highlight]: isWinner })}>
            <div className={classes.label}>
              {isWinner && (
                <Tooltip
                  placement="top"
                  title="Highest rated among compared products"
                  className={classes.tooltip}
                  sendOnEnterEvents={() =>
                    sendEvent({
                      name: 'engagement_hover',
                      engagementComponent: 'product_alternatives-comparison',
                      engagementDestination: 'show_winner-icon-definition',
                      engagementDetails: 'hover_winner-icon',
                    })
                  }
                >
                  <span>
                    <Icon icon={['fas', 'crown']} size={12} />
                  </span>
                </Tooltip>
              )}
              {RATING_NAMES[key]}
            </div>

            <Rating.Link
              className={classes.rating}
              average={listing.reviews.by_field[key]}
              isCompact
              size="small"
              hideTotals
            />
          </div>
        )
      })}
    </div>
  )
}

export default RatingComparison
